export class SetUtils {
  static toArray(set) {
    const array = [];
    set.forEach((elem) => {
      array.push(elem);
    });
    return array;
  }
  static fromArray(array) {
    const set = /* @__PURE__ */ new Set();
    for (let element of array) {
      set.add(element);
    }
    return set;
  }
  static union(set0, set1) {
    const newSet = /* @__PURE__ */ new Set();
    set0.forEach((val) => newSet.add(val));
    set1.forEach((val) => newSet.add(val));
    return newSet;
  }
  static intersection(set0, set1) {
    const newSet = /* @__PURE__ */ new Set();
    set0.forEach((val) => {
      if (set1.has(val)) {
        newSet.add(val);
      }
    });
    set1.forEach((val) => {
      if (set0.has(val)) {
        newSet.add(val);
      }
    });
    return newSet;
  }
  static difference(set0, set1) {
    const newSet = /* @__PURE__ */ new Set();
    set0.forEach((val) => {
      if (!set1.has(val)) {
        newSet.add(val);
      }
    });
    set1.forEach((val) => {
      if (!set0.has(val)) {
        newSet.add(val);
      }
    });
    return newSet;
  }
}
